import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Button,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
  Box,
  TextField,
  IconButton,
  Grid,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { LatLngBoundsLiteral, LatLngTuple } from 'leaflet';
import { endOfDay, startOfYear, isValid, startOfDay } from 'date-fns';
import { format } from 'date-fns-tz';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';
import { optionStyles } from './styles';
import cleanFilter from '../../assets/cleanFilter.svg';
import Add from '../../assets/add.svg';
import { filtroJson, jsonb } from '../../@types/jsonb';
import {
  gravidadesList,
  locationList,
  veiculosList,
  statusSAMU,
  tipoAcidentesList,
  tipoEngenharia,
  tipoEspecEngenharia,
  statusEngenharia,
  tipoFicalizacao,
  tipoFiscalizacaoEducacao,
  focoFiscalizacao,
  focoFiscalizacaoEducacao,
  severidade,
  locationTypeList,
} from './selectObjects';
import api from '../../services/api';
import { DrawPolygonType } from '../MapContent';
import AutoCompleteField from '../AutoCompleteVirtualized';
import { dateToBRT } from '../../utils/formatDate';

interface IBoundary {
  polygon_id: string;
  label: string;
  bbox: LatLngBoundsLiteral;
}

export interface IncFilterOpsType {
  endDate: string;
  startDate: string;
  veiculos: string[];
  gravidades: string[];
  location: string[];
  tipoAcidentes: string[];
  bairros: string;
  vias: string;
  regionais: string;
  drawPolygon: DrawPolygonType | {};
}
export interface IncSAMUFilterOpsType {
  endDate: string;
  startDate: string;
  veiculos: string[];
  gravidades: string[];
  tipoAcidentes: string[];
  bairros: string;
  Inconsistencia: string[];
  drawPolygon: DrawPolygonType | {};
}

export interface EngFilterOpsType {
  endDate: string;
  startDate: string;
  especificacao: string[];
  tipo: string[];
  status: string[];
  bairros: string;
  endereco: string;
  identificador: string[];
  protocolo: string[];
  solicitante: string;
  drawPolygon: DrawPolygonType | {};
}
export interface SurvFilterOpsType {
  endDate: string | any;
  startDate: string | any;
  bairros: string;
  focoMissao: string[];
  tipoMissao: string[];
  drawPolygon: DrawPolygonType | {};
}

export interface EducFilterOpsType {
  endDate: string;
  startDate: string;
  bairros: string;
  focoDaMissao: string[];
  tipoDaMissao: string[];
  drawPolygon: DrawPolygonType | {};
}

const initialFilterOps:
  | IncFilterOpsType
  | IncSAMUFilterOpsType
  | EngFilterOpsType
  | SurvFilterOpsType
  | EducFilterOpsType = {
  endDate: '',
  startDate: '',
  veiculos: [],
  gravidades: [],
  location: [],
  tipoAcidentes: [],
  bairros: '',
  vias: '',
  regionais: '',
  endereco: '',
  protocolo: [],
  identificador: [],
  solicitante: '',
  status: [],
  tipo: [],
  especificacao: [],
  drawPolygon: {},
  focoMissao: [],
  tipoMissao: [],
  focoDaMissao: [],
  tipoDaMissao: [],
  Inconsistencia: [],
};

const loadFilterStorage = (
  filterType: string,
):
  | IncFilterOpsType
  | IncSAMUFilterOpsType
  | EngFilterOpsType
  | SurvFilterOpsType
  | EducFilterOpsType => {
  let parsedJsonbObj:
    | IncFilterOpsType
    | IncSAMUFilterOpsType
    | EngFilterOpsType
    | SurvFilterOpsType
    | EducFilterOpsType = initialFilterOps;

  let loadedFilterOps: null | string = null;

  // Carrega a Configuração de Filtragem do LocaStorage

  if (
    filterType === 'sinistro' ||
    filterType === 'imprecisos' ||
    filterType === 'duplicidades'
  ) {
    loadedFilterOps = localStorage.getItem('incFilterOps');
  }
  if (filterType === 'sinistroSAMU') {
    loadedFilterOps = localStorage.getItem('incSAMUFilterOps');
  }
  if (filterType === 'engenharia') {
    loadedFilterOps = localStorage.getItem('engFilterOps');
  }
  if (filterType === 'fiscalizacao') {
    loadedFilterOps = localStorage.getItem('survFilterOps');
  }
  if (filterType === 'educ') {
    loadedFilterOps = localStorage.getItem('educFilterOps');
  }
  if (loadedFilterOps) {
    parsedJsonbObj = JSON.parse(loadedFilterOps);
    return parsedJsonbObj;
  }
  return parsedJsonbObj;
};

interface IProps {
  filterJson: React.Dispatch<React.SetStateAction<jsonb>>;
  dateMinSet: React.Dispatch<React.SetStateAction<string>>;
  dateMaxSet: React.Dispatch<React.SetStateAction<string>>;
  filterVehicles?: React.Dispatch<React.SetStateAction<string[]>> | undefined;
  setPositionSearch: React.Dispatch<React.SetStateAction<LatLngTuple>>;
  zoom: React.Dispatch<React.SetStateAction<number>>;
  id_boundary: React.Dispatch<React.SetStateAction<{}>>;
  bbox_boundary: React.Dispatch<React.SetStateAction<LatLngBoundsLiteral>>;
  routeTo: string;
  startDateMap: string;
  endDateMap: string;
  drawPolygon: DrawPolygonType | {};
  setDrawPolygon: React.Dispatch<React.SetStateAction<DrawPolygonType | {}>>;
  address: string;
  setAddress: React.Dispatch<React.SetStateAction<string>>;
  requester: string;
  setRequester: React.Dispatch<React.SetStateAction<string>>;
  onFilter?: () => void;
}

const FilterBar: React.FC<IProps> = ({
  filterJson,
  dateMinSet,
  dateMaxSet,
  filterVehicles,
  id_boundary,
  bbox_boundary,
  routeTo,
  startDateMap,
  endDateMap,
  drawPolygon,
  address,
  setAddress,
  requester,
  setRequester,
  setDrawPolygon,
  onFilter,
}) => {
  const authHeader = React.useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);
  const defaultStartDate = `${process.env.REACT_APP_MAP_START_DEFAULT_DATE}`;
  const defaultEndDate = `${process.env.REACT_APP_MAP_END_DEFAULT_DATE}`;

  const classes = optionStyles();

  const [startDate, setStartDate] = React.useState<string>(defaultStartDate);
  const [endDate, setEndDate] = React.useState<string>(defaultEndDate);
  const [veiculos, setVeiculos] = React.useState<string[]>([]);
  const [gravidades, setGravidades] = React.useState<string[]>([]);
  const [location, setLocation] = React.useState<string[]>([]);

  const [solicitante, setSolicitante] = React.useState<string[]>([]);
  const [endereco, setEndereco] = React.useState<string[]>([]);
  const [identificador, setIdentificador] = React.useState<string[]>([]);
  const [protocolo, setProtocolo] = React.useState<string[]>([]);

  const [locationTypes, setLocationTypes] = React.useState<string[]>([]);

  const [tipoAcidentes, setTipoAcidentes] = React.useState<string[]>([]);
  const [tipoSAMU, setTipoSAMU] = React.useState<string[]>([]);
  const [bairros, setBairros] = React.useState<string>('');
  const [bairrosList, setBairrosList] = useState<IBoundary[]>([
    {
      polygon_id: '',
      label: 'Carregando...',
      bbox: [
        [0, 0],
        [0, 0],
      ],
    },
  ]);
  const [vias, setVias] = React.useState<string>('');
  const [viasList, setViasList] = useState<IBoundary[]>([
    {
      polygon_id: '',
      label: 'Carregando...',
      bbox: [
        [0, 0],
        [0, 0],
      ],
    },
  ]);
  const [regionais, setRegionais] = React.useState<string>('');
  const [regionaisList, setRegionaisList] = useState<IBoundary[]>([
    {
      polygon_id: '',
      label: 'Carregando...',
      bbox: [
        [0, 0],
        [0, 0],
      ],
    },
  ]);
  const [idBoundary, setIdBoundary] = useState<{}>({ polygon_id: '' });
  const [bbox, setBbox] = useState<LatLngBoundsLiteral>([
    [0, 0],
    [0, 0],
  ]);
  const [admin, setAdmin] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [education, setEducation] = useState<boolean>(false);
  const [filterOps, setFilterOps] = useState<
    | IncFilterOpsType
    | IncSAMUFilterOpsType
    | EngFilterOpsType
    | SurvFilterOpsType
    | EducFilterOpsType
  >(loadFilterStorage(routeTo));

  const [loadingVia, setLoadingVia] = useState<boolean>(false);

  useEffect(() => {
    localStorage.removeItem('incFilterOps');

    // Ela mesma tá pegando as configurações de filtragem q ela mesma jogou lá
    if (routeTo === 'imprecisos') {
      const loadedFilterOps = localStorage.getItem('incFilterOps');

      if (typeof loadedFilterOps === 'string') {
        const ops: IncFilterOpsType = JSON.parse(loadedFilterOps);
        setStartDate(ops.startDate);
        setEndDate(ops.endDate);
      }
    }
    if (routeTo === 'duplicidades') {
      const loadedFilterOps = localStorage.getItem('incFilterOps');

      if (typeof loadedFilterOps === 'string') {
        const ops: IncFilterOpsType = JSON.parse(loadedFilterOps);
        setStartDate(ops.startDate);
        setEndDate(ops.endDate);
      }
    }
    if (routeTo === 'sinistro') {
      const loadedFilterOps = localStorage.getItem('incFilterOps');

      if (typeof loadedFilterOps === 'string') {
        const ops: IncFilterOpsType = JSON.parse(loadedFilterOps);
        setStartDate(ops.startDate);
        setEndDate(ops.endDate);
        setVeiculos(ops.veiculos);
        setGravidades(ops.gravidades);
        setLocation(ops.location);
        setTipoAcidentes(ops.tipoAcidentes);
      }
    }
    if (routeTo === 'sinistroSAMU') {
      const loadedFilterOps = localStorage.getItem('incSAMUFilterOps');

      if (typeof loadedFilterOps === 'string') {
        const ops: IncSAMUFilterOpsType = JSON.parse(loadedFilterOps);
        setStartDate(ops.startDate);
        setEndDate(ops.endDate);
        setVeiculos(ops.veiculos);
        setGravidades(ops.gravidades);
        setTipoSAMU(ops.Inconsistencia);
        setTipoAcidentes(ops.tipoAcidentes);
        setBairros(ops.bairros);
        setIdBoundary({ polygon_id: ops.bairros });
      }
    }
    if (routeTo === 'engenharia') {
      const loadedFilterOps = localStorage.getItem('engFilterOps');

      if (typeof loadedFilterOps === 'string') {
        const ops: EngFilterOpsType = JSON.parse(loadedFilterOps);
        setStartDate(ops.startDate);
        setEndDate(ops.endDate);
        setVeiculos(ops.tipo);
        setGravidades(ops.especificacao);
        setTipoAcidentes(ops.status);
        setBairros(ops.bairros);
        setIdBoundary({ polygon_id: ops.bairros });
        //setSolicitante(ops.solicitante);
        //setEndereco(ops.endereco);
        setAddress(ops.endereco);
        setRequester(ops.solicitante);
        setProtocolo(ops.protocolo);
      }
    }
    if (routeTo === 'fiscalizacao') {
      const loadedFilterOps = localStorage.getItem('survFilterOps');

      if (typeof loadedFilterOps === 'string') {
        const ops: SurvFilterOpsType = JSON.parse(loadedFilterOps);
        setStartDate(ops.startDate);
        setEndDate(ops.endDate);
        setBairros(ops.bairros);
        setIdBoundary({ polygon_id: ops.bairros });
        setVeiculos(ops.tipoMissao);
        setGravidades(ops.focoMissao);
        setFilterOps(ops);
      }
    }

    if (routeTo === 'educ') {
      const loadedFilterOps = localStorage.getItem('educFilterOps');

      if (typeof loadedFilterOps === 'string') {
        const ops: EducFilterOpsType = JSON.parse(loadedFilterOps);
        setStartDate(ops.startDate);
        setEndDate(ops.endDate);
        setBairros(ops.bairros);
        setIdBoundary({ polygon_id: ops.bairros });
        setVeiculos(ops.tipoDaMissao);
        setGravidades(ops.focoDaMissao);
        setFilterOps(ops);
      }
    }
  }, [routeTo]);

  useEffect(() => {
    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'educacao') {
          setEducation(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, []);

  useEffect(() => {
    // setStartDate(dateToBRT(new Date(endDateMap), startOfYear));
    // setEndDate(dateToBRT(new Date(endDateMap), endOfDay));
    setStartDate(startDateMap);
    setEndDate(endDateMap);
  }, [startDateMap, endDateMap]);

  useEffect(() => {
    async function neighboordhoodsName() {
      const count = await api.get('/api/boundarypolygons/', {
        headers: authHeader,
        params: {
          archived: false,
          details_only: true,
          limit: 1,
          boundary: `${process.env.REACT_APP_NEIGHBORHOOD_BOUNDARY_ID}`,
        },
      });

      const names = await api.get(`/api/boundarypolygons/?nogeom=true`, {
        headers: authHeader,
        params: {
          archived: false,
          details_only: true,
          limit: count.data.count,
          boundary: `${process.env.REACT_APP_NEIGHBORHOOD_BOUNDARY_ID}`,
        },
      });

      let n: IBoundary[] = names.data.results.map((bairro: any) => {
        return {
          polygon_id: bairro.uuid,
          label: bairro.data.NOME,
          bbox: [
            [bairro.bbox[0].lat, bairro.bbox[0].lon],
            [bairro.bbox[1].lat, bairro.bbox[1].lon],
          ],
        };
      });

      n = n.sort((a: IBoundary, b: IBoundary) => {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
      });

      // console.log(n);

      setBairrosList(n);
    }
    neighboordhoodsName();
  }, [authHeader]);

  useEffect(() => {
    async function regionalName() {
      const count = await api.get('/api/boundarypolygons/', {
        headers: authHeader,
        params: {
          archived: false,
          details_only: true,
          limit: 1,
          boundary: `${process.env.REACT_APP_REGIONAL_BOUNDARY_ID}`,
        },
      });

      const names = await api.get(`/api/boundarypolygons/?nogeom=true`, {
        headers: authHeader,
        params: {
          archived: false,
          details_only: true,
          limit: count.data.count,
          boundary: `${process.env.REACT_APP_REGIONAL_BOUNDARY_ID}`,
        },
      });

      let n: IBoundary[] = names.data.results.map((regional: any) => {
        return {
          polygon_id: regional.uuid,
          label: regional.data.regiao_adm,
          bbox: [
            [regional.bbox[0].lat, regional.bbox[0].lon],
            [regional.bbox[1].lat, regional.bbox[1].lon],
          ],
        };
      });

      n = n.sort((a: IBoundary, b: IBoundary) => {
        const numA = parseInt(a.label.split(' ')[1]);
        const numB = parseInt(b.label.split(' ')[1]);

        return numA - numB;
      });

      setRegionaisList(n);
    }
    regionalName();
  }, [authHeader]);

  useEffect(() => {
    async function streetsName() {
      let offset = 0;
      let results: any[] = [];
      setLoadingVia(true);
      while (true) {
        const names = await api.get(`/api/boundarypolygons/?nogeom=true`, {
          headers: authHeader,
          params: {
            archived: false,
            details_only: true,
            limit: 1000,
            offset: offset,
            boundary: `${process.env.REACT_APP_STREET_BOUNDARY_ID}`,
          },
        });

        offset += 1000;
        results = [...results, ...names.data.results];
        if (names.data.next == null) {
          break;
        }
      }

      results = results.filter((via: any) => {
        return via.data.nome_compl != '';
      });

      let n: IBoundary[] = results.map((via: any) => {
        let nomeVia = via.data.nome_compl.split('  ');
        nomeVia = nomeVia[0] + ' ' + nomeVia[1];
        return {
          polygon_id: via.uuid,
          label: nomeVia,
          bbox: [
            [via.bbox[0].lat, via.bbox[0].lon],
            [via.bbox[1].lat, via.bbox[1].lon],
          ],
        };
      });

      n = n.sort((a: IBoundary, b: IBoundary) => {
        return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
      });
      setLoadingVia(false);
      setViasList(n);
    }
    streetsName();
  }, [authHeader]);

  const history = useHistory();
  const navigate = (path: string) => {
    history.push(path);
  };

  const handleChange = {
    addLocationType(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;
      setLocationTypes(value as string[]);
    },
    addVeiculo(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;

      setVeiculos(value as string[]);

      setFilterOps((prev) => {
        if (routeTo === 'sinistro') {
          return { ...prev, veiculos: value as string[] };
        }
        if (routeTo === 'sinistroSAMU') {
          return { ...prev, veiculos: value as string[] };
        }
        if (routeTo === 'engenharia') {
          return { ...prev, tipo: value as string[] };
        }
        if (routeTo === 'fiscalizacao') {
          return { ...prev, tipoMissao: value as string[] };
        }
        if (routeTo === 'educ') {
          return { ...prev, tipoDaMissao: value as string[] };
        }
        return { ...prev, veiculos: value as string[] };
      });
    },

    addInconsiste(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;

      setTipoSAMU(value as string[]);

      setFilterOps((prev) => {
        return { ...prev, Inconsistencia: value as string[] };
      });
    },
    addEndereco(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;
      let stringValue: string = value as string;

      setAddress(stringValue);
      //setEndereco(valueToSet);
      setFilterOps((prev) => {
        return { ...prev, endereco: stringValue };
      });
    },

    addIndentificador(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;
      let valueToSet: string[];
      (value as string) == '' ? (valueToSet = []) : (valueToSet = [value] as string[]);

      setIdentificador(valueToSet);
      setFilterOps((prev) => {
        return { ...prev, identificador: valueToSet };
      });
    },
    addProtocolo(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;

      let valueToSet: string[];
      (value as string) == '' || value == null || value == undefined
        ? (valueToSet = [])
        : (valueToSet = [value] as string[]);

      setProtocolo(valueToSet);
      setFilterOps((prev) => {
        return { ...prev, protocolo: valueToSet };
      });
    },
    addSolicitante(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;
      let stringValue: string = value as string;

      setRequester(stringValue);
      //setSolicitante(valueToSet);
      setFilterOps((prev) => {
        return { ...prev, solicitante: stringValue };
      });
    },
    addGravidade(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;

      setGravidades(value as string[]);
      setFilterOps((prev) => {
        if (routeTo === 'sinistro') {
          return { ...prev, gravidades: value as string[] };
        }
        if (routeTo === 'sinistroSAMU') {
          return { ...prev, gravidades: value as string[] };
        }
        if (routeTo === 'engenharia') {
          return { ...prev, especificacao: value as string[] };
        }
        if (routeTo === 'fiscalizacao') {
          return { ...prev, focoMissao: value as string[] };
        }
        if (routeTo === 'educ') {
          return { ...prev, focoDaMissao: value as string[] };
        }
        return { ...prev, gravidades: value as string[] };
      });
    },

    addTipoAcidente(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;

      setTipoAcidentes(value as string[]);
      setFilterOps((prev) => {
        if (routeTo === 'sinistro') {
          return { ...prev, tipoAcidentes: value as string[] };
        }
        if (routeTo === 'sinistroSAMU') {
          return { ...prev, tipoAcidentes: value as string[] };
        }
        if (routeTo === 'engenharia') {
          return { ...prev, status: value as string[] };
        }
        return { ...prev, tipoAcidentes: value as string[] };
      });
    },

    addBairro(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;

      setBairros(value as string);
      setFilterOps((prev) => {
        return { ...prev, bairros: value as string };
      });
    },

    addVia(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;

      setVias(value as string);
      setFilterOps((prev) => {
        return { ...prev, vias: value as string };
      });
    },

    addStartDate(value: Date | null) {
      if (value && isValid(value)) {
        setStartDate(dateToBRT(value, startOfDay));
        setFilterOps((prev) => {
          return {
            ...prev,
            startDate: dateToBRT(value, startOfDay),
          };
        });
        if (value >= new Date(endDate)) {
          this.addEndDate(value);
        }
      }
    },

    addEndDate(value: Date | null) {
      if (value && isValid(value)) {
        setEndDate(dateToBRT(value, endOfDay));
        setFilterOps((prev) => {
          return {
            ...prev,
            endDate: dateToBRT(value, endOfDay),
          };
        });
        if (value <= new Date(startDate)) {
          this.addStartDate(value);
        }
      }
    },

    addLocation(event: React.ChangeEvent<{ value: unknown }>) {
      const { value } = event.target;

      setLocation(value as string[]);
      setFilterOps((prev) => {
        if (routeTo === 'sinistro') {
          return { ...prev, location: value as string[] };
        }
        return { ...prev, location: value as string[] };
      });
    },

    clearFilters() {
      setStartDate(startDateMap);
      setEndDate(endDateMap);

      dateMinSet(startDateMap);
      dateMaxSet(endDateMap);

      filterVehicles?.([]);

      setVeiculos([]);
      setGravidades([]);
      setLocation([]);
      setTipoAcidentes([]);
      setTipoSAMU([]);
      // setEndereco([]);
      // setSolicitante([]);
      setAddress('');
      setProtocolo([]);
      setIdentificador([]);
      setRequester('');
      setBairros('');
      setIdBoundary({});
      setBbox([]);
      id_boundary(idBoundary);
      bbox_boundary(bbox);
      const json: jsonb = { jsonb: {} };
      filterJson(json);
      setDrawPolygon({});
      setFilterOps(initialFilterOps);

      if (routeTo === 'sinistro') {
        localStorage.removeItem('incFilterOps');
        localStorage.removeItem('incMapViewport');
      } else if (routeTo === 'sinistroSAMU') {
        localStorage.removeItem('incSAMUFilterOps');
        localStorage.removeItem('incSAMUMapViewport');
      }
      if (routeTo === 'engenharia') localStorage.removeItem('engFilterOps');
      if (routeTo === 'fiscalizacao') localStorage.removeItem('survFilterOps');
      if (routeTo === 'educ') localStorage.removeItem('educFilterOps');
    },
  };

  const setFilters = () => {
    const vehiclesArray = veiculos.map((item) => {
      return [item];
    });

    const locationTypeArray = locationTypes.map((item) => {
      return [item];
    });

    const gravityArray = gravidades.map((item) => {
      return [item];
    });

    const accidentTypeArray = tipoAcidentes.map((item) => {
      return [item];
    });
    const samuTypeArray = tipoSAMU.map((item) => {
      return [item];
    });

    let filter1: filtroJson;
    let filter2: filtroJson;
    let filter3: filtroJson;
    let filter4: filtroJson;
    let filter5: filtroJson;
    let filter6: filtroJson;
    let filter7: filtroJson;
    // Não entendo por que criar tantas variaveis filtro mas foram criadas.
    // Pela analise do codigo já escrito, acredito que seja um 'filter' por driver....
    // Nesse caso, irei criar um filter novo para cada caso de driver novo que precisa de um filtro, embora não
    // vejo isso como uma boa ideia de otimização ou design de codigo.

    if (routeTo === 'sinistro') {
      filter1 = {
        driverVeiculo: {
          'Tipo Veículo': {
            _rule_type: 'containment_multiple',
            contains: ['', ['']],
          },
        },
      };

      filter2 = {
        driverVitima: {
          'Gravidade da Lesão': {
            _rule_type: 'containment_multiple',
            contains: ['', ['']],
          },
        },
      };

      filter3 = {
        driverIncidenteDetails: {
          Natureza: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
          Severidade: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter4 = {};
      filter5 = {};
      filter6 = {};
      filter7 = {};
    } else if (routeTo === 'sinistroSAMU') {
      filter1 = {
        driverVeiculo: {
          'Tipo Veículo': {
            _rule_type: 'containment_multiple',
            contains: ['', ['']],
          },
        },
      };

      filter2 = {
        driverVitima: {
          'Gravidade da Lesão': {
            _rule_type: 'containment_multiple',
            contains: ['', ['']],
          },
        },
      };

      filter3 = {
        driverIncidenteDetails: {
          Inconsistencia: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
          Natureza: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
          Severidade: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter4 = {};
      filter5 = {};
      filter6 = {};
      filter7 = {};
    } else if (routeTo === 'engenharia') {
      filter1 = {
        driverEngineeringIntervention: {
          Tipo: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter2 = {
        driverEngineeringIntervention: {
          Especificação: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter3 = {
        driverEngineeringInterventionProject: {
          Status: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
          'Identificador do Projeto': {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter4 = {
        driverEngineeringLocation: {
          'Endereço 1': {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };
      filter5 = {
        driverEngineeringInterventionRequest: {
          'Número do Protocolo': {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
          'Nome do Solicitante': {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };
      filter6 = {};
      filter7 = {};
    } else if (routeTo === 'educ') {
      filter6 = {
        educationMission: {
          tipoDaMissao: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter7 = {
        educationMission: {
          focoDaMissao: {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter1 = {};
      filter2 = {};
      filter3 = {};
      filter4 = {};
      filter5 = {};
    } else if (routeTo === 'fiscalizacao') {
      filter1 = {
        driverSurveillanceMission: {
          'Tipo da Missão': {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter2 = {
        driverSurveillanceMission: {
          'Foco da Missão': {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };

      filter3 = {};
      filter4 = {};
      filter5 = {};
      filter6 = {};
      filter7 = {};
    } else if (routeTo === 'imprecisos') {
      filter4 = {
        driverIncidenteDetails: {
          Natureza: {
            _rule_type: 'containment',
            contains: [],
          },
          Severidade: {
            _rule_type: 'containment',
            contains: [],
          },
          'Location Type': {
            _rule_type: 'containment',
            contains: ['', ['']],
          },
        },
      };
      filter1 = {};
      filter2 = {};
      filter3 = {};
      filter5 = {};
      filter6 = {};
      filter7 = {};
    } else {
      filter1 = {};
      filter2 = {};
      filter3 = {};
      filter4 = {};
      filter5 = {};
      filter6 = {};
      filter7 = {};
    }
    // Jsonb Responsável por armazenar as configurações de filtragem
    const json: jsonb = { jsonb: {} };
    if (veiculos) {
      const jsonVeiculo: Array<string | string[]> = [];
      vehiclesArray.forEach((item) => {
        if (routeTo === 'sinistro' || routeTo === 'sinistroSAMU' || routeTo === 'educ') {
          if (item[0] === 'Automóvel') {
            jsonVeiculo.push('Caminhonete');
            jsonVeiculo.push(['Caminhonete']);
            jsonVeiculo.push('Utilitário');
            jsonVeiculo.push(['Utilitário']);
            jsonVeiculo.push('Camioneta');
            jsonVeiculo.push(['Camioneta']);
          } else if (item[0] === 'Caminhão') {
            jsonVeiculo.push('Caminhão 2 Eixos');
            jsonVeiculo.push(['Caminhão 2 Eixos']);
            jsonVeiculo.push('Caminhão c/ Semi-Reboque');
            jsonVeiculo.push(['Caminhão c/ Semi-Reboque']);
            jsonVeiculo.push('Caminhão 4 Eixos');
            jsonVeiculo.push(['Caminhão 4 Eixos']);
            jsonVeiculo.push('Caminhão Trator');
            jsonVeiculo.push(['Caminhão Trator']);
            jsonVeiculo.push('Caminhão 3 Eixos');
            jsonVeiculo.push(['Caminhão 3 Eixos']);
          } else if (item[0] === 'Ônibus') {
            jsonVeiculo.push('Microônibus');
            jsonVeiculo.push(['Microônibus']);
          } else if (item[0] === 'Motocicleta') {
            jsonVeiculo.push('Ciclomotor');
            jsonVeiculo.push(['Ciclomotor']);
            jsonVeiculo.push('Motoneta');
            jsonVeiculo.push(['Motoneta']);
          } else if (item[0] === 'Outros') {
            jsonVeiculo.push('Triciclo');
            jsonVeiculo.push(['Triciclo']);
            jsonVeiculo.push('Tração Animal');
            jsonVeiculo.push(['Tração Animal']);
            jsonVeiculo.push('Trem');
            jsonVeiculo.push(['Trem']);
            jsonVeiculo.push('Trator');
            jsonVeiculo.push(['Trator']);
            jsonVeiculo.push('Com Reboque');
            jsonVeiculo.push(['Com Reboque']);
          }
        }

        jsonVeiculo.push(item[0]);
        jsonVeiculo.push(item);
      });

      // if (filter2.driverVitima !== undefined){
      //   filter2.driverVitima['Gravidade da Lesão'].contains = jsonVeiculo;
      // }

      if (filter1.driverVeiculo !== undefined) {
        filter1.driverVeiculo['Tipo Veículo'].contains = jsonVeiculo;
        json.jsonb = {
          ...json.jsonb,
          driverVeiculo: filter1.driverVeiculo,
        };
      } else if (
        filter1.driverEngineeringIntervention !== undefined &&
        filter1.driverEngineeringIntervention.Tipo !== undefined
      ) {
        filter1.driverEngineeringIntervention.Tipo.contains = jsonVeiculo;
        json.jsonb = {
          ...json.jsonb,
          driverEngineeringIntervention: {
            ...json.jsonb.driverEngineeringIntervention,
            Tipo: filter1.driverEngineeringIntervention.Tipo,
          },
        };
      } else if (
        filter1.driverSurveillanceMission !== undefined &&
        filter1.driverSurveillanceMission['Tipo da Missão'] !== undefined
      ) {
        filter1.driverSurveillanceMission['Tipo da Missão'].contains = jsonVeiculo;
        json.jsonb = {
          ...json.jsonb,
          driverSurveillanceMission: {
            ...json.jsonb.driverSurveillanceMission,
            'Tipo da Missão': filter1.driverSurveillanceMission['Tipo da Missão'],
          },
        };
      } else if (
        filter6.educationMission !== undefined &&
        filter6.educationMission.tipoDaMissao !== undefined
      ) {
        filter6.educationMission.tipoDaMissao.contains = jsonVeiculo;
        json.jsonb = {
          ...json.jsonb,
          educationMission: {
            ...json.jsonb.educationMission,
            tipoDaMissao: filter6.educationMission.tipoDaMissao,
          },
        };
      }
    }

    if (gravidades) {
      const jsonGravidades: Array<string | string[]> = [];
      // Adiciona as Gravidades na Filtragem
      gravityArray.forEach((item) => {
        jsonGravidades.push(item[0]);
        jsonGravidades.push(item);
      });

      if (filter3.driverIncidenteDetails?.Severidade !== undefined) {
        filter3.driverIncidenteDetails.Severidade.contains = jsonGravidades;
        json.jsonb = {
          ...json.jsonb,
          driverIncidenteDetails: filter3.driverIncidenteDetails,
        };
      } else if (
        filter2.driverEngineeringIntervention !== undefined &&
        filter2.driverEngineeringIntervention['Especificação'] !== undefined
      ) {
        filter2.driverEngineeringIntervention['Especificação'].contains = jsonGravidades;
        json.jsonb = {
          ...json.jsonb,
          driverEngineeringIntervention: {
            ...json.jsonb.driverEngineeringIntervention,
            Especificação: filter2.driverEngineeringIntervention['Especificação'],
          },
        };
      } else if (
        filter2.driverSurveillanceMission !== undefined &&
        filter2.driverSurveillanceMission['Foco da Missão'] !== undefined
      ) {
        filter2.driverSurveillanceMission['Foco da Missão'].contains = jsonGravidades;
        json.jsonb = {
          ...json.jsonb,
          driverSurveillanceMission: {
            ...json.jsonb.driverSurveillanceMission,
            'Foco da Missão': filter2.driverSurveillanceMission['Foco da Missão'],
          },
        };
      } else if (
        filter7.educationMission !== undefined &&
        filter7.educationMission.focoDaMissao !== undefined
      ) {
        filter7.educationMission.focoDaMissao.contains = jsonGravidades;
        json.jsonb = {
          ...json.jsonb,
          educationMission: {
            ...json.jsonb.educationMission,
            focoDaMissao: filter7.educationMission.focoDaMissao,
          },
        };
      }
    }

    if (tipoAcidentes) {
      const jsonAcidentes: Array<string | string[]> = [];
      const jsonIdentificador: Array<string | string[]> = [];
      identificador.length > 0 &&
        identificador.forEach((item) => {
          jsonIdentificador.push([item]);
          jsonIdentificador.push(item);
        });

      accidentTypeArray.forEach((item) => {
        if (routeTo === 'sinistro' || routeTo === 'sinistroSAMU') {
          if (item[0] === 'Colisão') {
            jsonAcidentes.push('Colisão Transversal');
            jsonAcidentes.push(['Colisão Transversal']);
            jsonAcidentes.push('Colisão Traseira');
            jsonAcidentes.push(['Colisão Traseira']);
            jsonAcidentes.push('Colisão Lateral ');
            jsonAcidentes.push(['Colisão Lateral']);
            jsonAcidentes.push('Colisão Frontal');
            jsonAcidentes.push(['Colisão Frontal']);
            jsonAcidentes.push('Colisão Lateral Sentido Oposto');
            jsonAcidentes.push(['Colisão Lateral Sentido Oposto']);
            jsonAcidentes.push('Engavetamento');
            jsonAcidentes.push(['Engavetamento']);
          } else if (item[0] === 'Choque c/ Obstáculo Fixo') {
            jsonAcidentes.push('Choque');
            jsonAcidentes.push(['Choque']);
          } else if (item[0] === 'Capotamento') {
            jsonAcidentes.push('Tombamento');
            jsonAcidentes.push(['Tombamento']);
          } else if (item[0] === 'Outros') {
            jsonAcidentes.push('Atropelamento de Animal');
            jsonAcidentes.push(['Atropelamento de Animal']);
            jsonAcidentes.push('Acidente Pessoal');
            jsonAcidentes.push(['Acidente Pessoal']);
          }
        }
        jsonAcidentes.push(item[0]);
        jsonAcidentes.push(item);
      });
      if (filter3.driverIncidenteDetails !== undefined) {
        filter3.driverIncidenteDetails.Natureza.contains = jsonAcidentes;
        json.jsonb = {
          ...json.jsonb,
          driverIncidenteDetails: filter3.driverIncidenteDetails,
        };
      } else if (
        filter3.driverEngineeringInterventionProject !== undefined &&
        filter3.driverEngineeringInterventionProject.Status !== undefined &&
        filter3.driverEngineeringInterventionProject['Identificador do Projeto'] !==
          undefined
      ) {
        filter3.driverEngineeringInterventionProject.Status.contains = jsonAcidentes;
        filter3.driverEngineeringInterventionProject[
          'Identificador do Projeto'
        ].contains = jsonIdentificador;

        json.jsonb = {
          ...json.jsonb,
          driverEngineeringInterventionProject: {
            ...json.jsonb.driverEngineeringInterventionProject,
            Status: filter3.driverEngineeringInterventionProject.Status,
            'Identificador do Projeto':
              filter3.driverEngineeringInterventionProject['Identificador do Projeto'],
          },
        };
      }
    }
    if (routeTo === 'sinistroSAMU') {
      const jsonSAMU: Array<string | string[]> = [];
      // Adiciona StatusSAMU na Filtragem
      samuTypeArray.forEach((item) => {
        jsonSAMU.push(item[0]);
        jsonSAMU.push(item);
      });

      if (filter3.driverIncidenteDetails?.Inconsistencia !== undefined) {
        filter3.driverIncidenteDetails.Inconsistencia.contains = jsonSAMU;
        json.jsonb = {
          ...json.jsonb,
          driverIncidenteDetails: filter3.driverIncidenteDetails,
        };
      }
    }

    if (routeTo === 'engenharia') {
      const jsonProtocolo: Array<string | string[]> = [];
      const jsonSolicitante: Array<string | string[]> = [];

      protocolo.length > 0 &&
        protocolo.forEach((item) => {
          jsonProtocolo.push([item]);
          jsonProtocolo.push(item);
        });
      //console.log('routeTo = engenharia');

      if (
        filter5.driverEngineeringInterventionRequest !== undefined &&
        filter5.driverEngineeringInterventionRequest?.['Número do Protocolo'] !==
          undefined &&
        filter5.driverEngineeringInterventionRequest['Nome do Solicitante'] !== undefined
      ) {
        //console.log("filter5.driverEngineeringInterventionRequest?.['Número do Protocolo']!== undefined");

        filter5.driverEngineeringInterventionRequest[
          'Número do Protocolo'
        ].contains = jsonProtocolo;
        filter5.driverEngineeringInterventionRequest[
          'Nome do Solicitante'
        ].contains = jsonSolicitante;
        json.jsonb = {
          ...json.jsonb,
          driverEngineeringInterventionRequest: {
            ...json.jsonb.driverEngineeringInterventionRequest,
            'Número do Protocolo':
              filter5.driverEngineeringInterventionRequest['Número do Protocolo'],
            'Nome do Solicitante':
              filter5.driverEngineeringInterventionRequest['Nome do Solicitante'],
          },
        };
      }
    }

    if (routeTo == 'imprecisos') {
      const jsonImprecisos: Array<string | string[]> = [];

      locationTypeArray.forEach((item) => {
        jsonImprecisos.push(item[0]);
        jsonImprecisos.push(item);
      });

      if (filter4.driverIncidenteDetails?.['Location Type'] !== undefined) {
        filter4.driverIncidenteDetails['Location Type'].contains = jsonImprecisos;
        json.jsonb = {
          ...json.jsonb,
          driverIncidenteDetails: filter4.driverIncidenteDetails,
        };
      }
    }

    dateMinSet(startDate);
    filterVehicles?.(veiculos);
    dateMaxSet(endDate);
    id_boundary(idBoundary);
    bbox_boundary(bbox);
    filterJson(json);

    // Setando a Filtragem no Local Storage
    if (routeTo === 'imprecisos') {
      localStorage.setItem('incFilterOps', JSON.stringify({ ...filterOps, drawPolygon }));
    }
    if (routeTo === 'duplicidades') {
      localStorage.setItem('incFilterOps', JSON.stringify({ ...filterOps, drawPolygon }));
    }
    if (routeTo === 'sinistro') {
      // console.log("filterops local storage: " + filterOps.startDate)

      localStorage.setItem('incFilterOps', JSON.stringify({ ...filterOps, drawPolygon }));
    } else if (routeTo === 'sinistroSAMU') {
      localStorage.setItem(
        'incSAMUFilterOps',
        JSON.stringify({ ...filterOps, drawPolygon }),
      );
    } else if (routeTo === 'engenharia') {
      localStorage.setItem('engFilterOps', JSON.stringify({ ...filterOps, drawPolygon }));
    } else if (routeTo === 'fiscalizacao') {
      localStorage.setItem(
        'survFilterOps',
        JSON.stringify({ ...filterOps, drawPolygon }),
      );
    } else if (routeTo === 'educ') {
      localStorage.setItem(
        'educFilterOps',
        JSON.stringify({ ...filterOps, drawPolygon }),
      );
    }

    if (onFilter) {
      onFilter();
    }
  };

  const returnLegend = (filterNumber: Number): string => {
    if (filterNumber === 1) {
      if (routeTo === 'sinistro' || routeTo === 'sinistroSAMU') {
        if (veiculos.length === 0) {
          return 'Veículo (Todos)';
        }
        return 'Veículo';
      }
      if (routeTo === 'engenharia') {
        if (veiculos.length === 0) {
          return 'Tipo de intervenção (Todos)';
        }
        return 'Tipo de intervenção';
      }
      if (routeTo === 'educ') {
        if (veiculos.length === 0) {
          return 'Tipo da missão (Todos)';
        }
        return 'Tipo da missão';
        // if (veiculos.length === 0) {
        //   return 'Tipo da missão (Todos)';
        // }
      }

      if (veiculos.length === 0) {
        return 'Tipo de fiscalização (Todos)';
      }
      return 'Tipo de fiscalização';
    }
    if (filterNumber === 2) {
      if (routeTo === 'sinistro' || routeTo === 'sinistroSAMU') {
        if (gravidades.length === 0) {
          return 'Severidade (Todos)';
        }
        return 'Severidade';
      }
      if (routeTo === 'engenharia') {
        if (gravidades.length === 0) {
          return 'Especificação (Todos)';
        }
        return 'Especificação';
      }
      if (routeTo === 'educ') {
        if (gravidades.length === 0) {
          return 'Foco da missão (Todos)';
        }
        return 'Foco da missão';
      }
      if (gravidades.length === 0) {
        return 'Foco de fiscalização (Todos)';
      }
      return 'Foco de fiscalização';
    }
    if (filterNumber === 3) {
      if (routeTo === 'sinistro' || routeTo === 'sinistroSAMU') {
        if (tipoAcidentes.length === 0) {
          return 'Natureza (Todos)';
        }
        return 'Natureza';
      }
      if (routeTo === 'engenharia') {
        if (tipoAcidentes.length === 0) {
          return 'Status (Todos)';
        }
        return 'Status';
      }
      if (tipoAcidentes.length === 0) {
        return 'Fisc (Todos)';
      }
      return 'Fisc';
    }
    if (filterNumber === 4) {
      if (routeTo === 'sinistroSAMU') {
        if (tipoSAMU.length === 0) {
          return 'Inconsistência (Todos)';
        }
        return 'Inconsistência';
      }
    }
    if (filterNumber === 5) {
      if (routeTo === 'sinistro') {
        if (location.length === 0) {
          return 'Localização (Todos)';
        }
        return 'Localização';
      }
    }
    return '';
  };

  return (
    <>
      <AppBar position="static" variant="outlined" color="inherit">
        <Toolbar className={classes.filterBar}>
          <Box component="div" className={classes.responsive}>
            <FormControl
              margin="dense"
              className={classes.formControl}
              variant="outlined"
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                <KeyboardDatePicker
                  variant="inline"
                  format="dd/MM/yyyy"
                  placeholder="dd/mm/yyyy"
                  className={classes.dateInput}
                  minDate={startDateMap}
                  maxDate={endDateMap}
                  value={startDate || filterOps.startDate}
                  onChange={(event) => handleChange.addStartDate(event)}
                  inputVariant="outlined"
                  inputProps={{
                    style: { padding: '0 0 0 8px', marginRight: '-20px', height: 34 },
                  }}
                  showTodayButton
                  size="small"
                  error={false}
                />
              </MuiPickersUtilsProvider>
            </FormControl>
            <FormControl
              margin="dense"
              className={classes.formControl}
              variant="outlined"
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
                <KeyboardDatePicker
                  variant="inline"
                  format="dd/MM/yyyy"
                  placeholder="dd/mm/yyyy"
                  className={classes.dateInput}
                  minDate={startDateMap}
                  maxDate={endDateMap}
                  value={endDate || filterOps.endDate}
                  onChange={(event) => handleChange.addEndDate(event)}
                  inputVariant="outlined"
                  inputProps={{
                    style: { padding: '0 0 0 8px', marginRight: '-20px', height: 34 },
                  }}
                  showTodayButton
                  size="small"
                  error={false}
                />
              </MuiPickersUtilsProvider>
            </FormControl>
            {routeTo === 'imprecisos' ? (
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <InputLabel id="location-type-label" className={classes.selectLabel}>
                  {'Tipo de localização'}
                </InputLabel>
                <Select
                  labelId="location-type-label"
                  label={'Tipo de localização'}
                  multiple
                  className={classes.selectField}
                  value={locationTypes}
                  onChange={handleChange.addLocationType}
                  SelectDisplayProps={{ style: { fontSize: 14, fontStyle: 'italic' } }}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {locationTypeList.map((item) => (
                    <MenuItem value={item.label} key={item.label}>
                      <Checkbox checked={locationTypes.indexOf(item.label) > -1} />
                      <ListItemText primary={item.label} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : routeTo !== 'duplicidades' ? (
              <>
                <FormControl
                  margin="dense"
                  className={classes.formControl}
                  variant="outlined"
                >
                  <InputLabel id="vehicles-label" className={classes.selectLabel}>
                    {returnLegend(1)}
                  </InputLabel>
                  <Select
                    labelId="vehicles-label"
                    label={returnLegend(1)}
                    multiple
                    className={classes.selectField}
                    value={veiculos}
                    onChange={handleChange.addVeiculo}
                    SelectDisplayProps={{ style: { fontSize: 14, fontStyle: 'italic' } }}
                    renderValue={(selected) => (selected as string[]).join(', ')}
                  >
                    {(routeTo === 'sinistro' || routeTo === 'sinistroSAMU') &&
                      veiculosList.map((item) => (
                        <MenuItem value={item.label} key={item.label}>
                          <Checkbox checked={veiculos.indexOf(item.label) > -1} />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    {routeTo === 'engenharia' &&
                      tipoEngenharia.map((item) => (
                        <MenuItem value={item.label} key={item.label}>
                          <Checkbox checked={veiculos.indexOf(item.label) > -1} />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    {routeTo === 'fiscalizacao' &&
                      tipoFicalizacao.map((item) => (
                        <MenuItem value={item.label} key={item.label}>
                          <Checkbox checked={veiculos.indexOf(item.label) > -1} />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    {routeTo === 'educ' &&
                      tipoFiscalizacaoEducacao.map((item) => (
                        <MenuItem value={item.label} key={item.label}>
                          <Checkbox checked={veiculos.indexOf(item.label) > -1} />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <FormControl
                  margin="dense"
                  className={classes.formControl}
                  variant="outlined"
                >
                  <InputLabel id="severity-label" className={classes.selectLabel}>
                    {returnLegend(2)}
                  </InputLabel>
                  <Select
                    labelId="severity-label"
                    label={returnLegend(2)}
                    multiple
                    className={classes.selectField}
                    value={gravidades}
                    onChange={handleChange.addGravidade}
                    renderValue={(selected) => (selected as string[]).join(', ')}
                  >
                    {(routeTo === 'sinistro' || routeTo === 'sinistroSAMU') &&
                      gravidadesList.map((item) => (
                        <MenuItem value={item.label} key={item.label}>
                          <Checkbox checked={gravidades.indexOf(item.label) > -1} />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    {routeTo === 'engenharia' &&
                      tipoEspecEngenharia.map((item) => (
                        <MenuItem value={item.label} key={item.label}>
                          <Checkbox checked={gravidades.indexOf(item.label) > -1} />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    {routeTo === 'fiscalizacao' &&
                      focoFiscalizacao.map((item) => (
                        <MenuItem value={item.label} key={item.label}>
                          <Checkbox checked={gravidades.indexOf(item.label) > -1} />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                    {routeTo === 'educ' &&
                      focoFiscalizacaoEducacao.map((item) => (
                        <MenuItem value={item.label} key={item.label}>
                          <Checkbox checked={gravidades.indexOf(item.label) > -1} />
                          <ListItemText primary={item.label} />
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </>
            ) : (
              <></>
            )}

            {routeTo === 'sinistro' ||
            routeTo === 'sinistroSAMU' ||
            routeTo === 'engenharia' ? (
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <InputLabel id="nature-label" className={classes.selectLabel}>
                  {returnLegend(3)}
                </InputLabel>
                <Select
                  labelId="nature-label"
                  label={returnLegend(3)}
                  multiple
                  className={classes.selectField}
                  value={tipoAcidentes}
                  onChange={handleChange.addTipoAcidente}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {(routeTo === 'sinistro' || routeTo === 'sinistroSAMU') &&
                    tipoAcidentesList.map((item) => (
                      <MenuItem value={item.label} key={item.label}>
                        <Checkbox checked={tipoAcidentes.indexOf(item.label) > -1} />
                        <ListItemText primary={item.label} />
                      </MenuItem>
                    ))}
                  {routeTo === 'engenharia' &&
                    statusEngenharia.map((item) => (
                      <MenuItem value={item.label} key={item.label}>
                        <Checkbox checked={tipoAcidentes.indexOf(item.label) > -1} />
                        <ListItemText primary={item.label} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            ) : null}

            {routeTo === 'sinistroSAMU' && (
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <InputLabel id="vehicles-label" className={classes.selectLabel}>
                  {returnLegend(4)}
                </InputLabel>
                <Select
                  labelId="vehicles-label"
                  label={returnLegend(4)}
                  multiple
                  className={classes.selectField}
                  value={tipoSAMU}
                  onChange={handleChange.addInconsiste}
                  SelectDisplayProps={{ style: { fontSize: 14, fontStyle: 'italic' } }}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {routeTo === 'sinistroSAMU' &&
                    statusSAMU.map((item) => (
                      <MenuItem value={item.label} key={item.label}>
                        <Checkbox checked={tipoSAMU.indexOf(item.label) > -1} />
                        <ListItemText primary={item.label} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}

            {/* <FormControl
              margin="dense"
              className={classes.formControl}
              variant="outlined"
            >
              <InputLabel id="neighborhood-label" className={classes.selectLabel}>
                Bairro
              </InputLabel>
              <Select
                labelId="neighborhood-label"
                label="Bairro"
                className={classes.selectField}
                value={bairros}
                onChange={handleChange.addBairro}
              >
                <MenuItem
                  onClick={() => {
                    setIdBoundary({});
                    setBbox([]);
                  }}
                  value=""
                >
                  Todos
                </MenuItem>
                {bairrosList.map((item) => (
                  <MenuItem
                    value={item.polygon_id}
                    key={item.polygon_id}
                    onClick={() => {
                      setIdBoundary({ polygon_id: item.polygon_id });
                      setBbox(item.bbox);
                    }}
                  >
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl> */}

            <FormControl margin="dense" className={classes.formControl}>
              <Button
                className={classes.submitButton}
                variant="contained"
                onClick={setFilters}
                disableElevation
              >
                Filtrar
              </Button>
            </FormControl>
            <IconButton
              className={classes.filterIconButton}
              onClick={handleChange.clearFilters}
            >
              <img
                title="Limpar filtros"
                className={classes.filterIcon}
                src={cleanFilter}
                alt="Remove"
              />
            </IconButton>
          </Box>
          {routeTo === 'sinistro' && (
            <Box component="div" className={classes.responsive}>
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <AutoCompleteField
                  options={
                    bairrosList &&
                    bairrosList.map((item) => {
                      return { name: item.label };
                    })
                  }
                  label="Bairro"
                  filter={true}
                  placeholder="Informe o bairro"
                  disabled={loadingVia}
                  value={bairros}
                  onChange={(val) => {
                    let bairro = bairrosList.find((item) => item.label === val);
                    if (bairro) {
                      setIdBoundary({ polygon_id: bairro.polygon_id });
                      setBbox(bairro.bbox);
                      setBairros(val as string);
                      setRegionais('');
                      setVias('');
                    } else {
                      setIdBoundary({ polygon_id: '' });
                      setBbox([]);
                      setBairros('');
                    }
                  }}
                />
              </FormControl>

              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <AutoCompleteField
                  options={
                    viasList &&
                    viasList.map((item) => {
                      return { name: item.label };
                    })
                  }
                  label="Via"
                  filter={true}
                  placeholder="Informe a via"
                  value={vias}
                  onChange={(val) => {
                    let via = viasList.find((item) => item.label === val);
                    if (via) {
                      setIdBoundary({ polygon_id: via.polygon_id });
                      setBbox(via.bbox);
                      setVias(val as string);
                      setBairros('');
                      setRegionais('');
                    } else {
                      setIdBoundary({ polygon_id: '' });
                      setBbox([]);
                      setVias('');
                    }
                  }}
                />
              </FormControl>
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <AutoCompleteField
                  options={
                    regionaisList &&
                    regionaisList.map((item) => {
                      return { name: item.label };
                    })
                  }
                  label="Regional"
                  filter={true}
                  placeholder="Informe a regional"
                  value={regionais}
                  onChange={(val) => {
                    let regional = regionaisList.find((item) => item.label === val);
                    if (regional) {
                      setIdBoundary({ polygon_id: regional.polygon_id });
                      setBbox(regional.bbox);
                      setRegionais(val as string);
                      setBairros('');
                      setVias('');
                    } else {
                      setIdBoundary({ polygon_id: '' });
                      setBbox([]);
                      setRegionais('');
                    }
                  }}
                />
              </FormControl>

              {/* Location */}
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <InputLabel id="Location" className={classes.selectLabel}>
                  {returnLegend(5)}
                </InputLabel>
                <Select
                  labelId="Location"
                  label={returnLegend(5)}
                  multiple
                  className={classes.selectField}
                  value={location}
                  onChange={handleChange.addLocation}
                  renderValue={(selected) => (selected as string[]).join(', ')}
                >
                  {routeTo === 'sinistro' &&
                    locationList.map((item) => (
                      <MenuItem value={item.label} key={item.label}>
                        <Checkbox checked={location.indexOf(item.label) > -1} />
                        <ListItemText primary={item.label} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          )}
          {routeTo === 'engenharia' && (
            <Box component="div" className={classes.responsive}>
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <TextField
                  size={'small'}
                  value={address}
                  onChange={handleChange.addEndereco}
                  id="outlined-basic"
                  label="Endereço"
                  variant="outlined"
                />
              </FormControl>
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <TextField
                  size={'small'}
                  value={identificador}
                  onChange={handleChange.addIndentificador}
                  id="outlined-basic"
                  label="Identificador"
                  variant="outlined"
                />
              </FormControl>
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <TextField
                  size={'small'}
                  value={protocolo}
                  onChange={handleChange.addProtocolo}
                  id="outlined-basic"
                  label="Protocolo"
                  variant="outlined"
                />
              </FormControl>
              <FormControl
                margin="dense"
                className={classes.formControl}
                variant="outlined"
              >
                <TextField
                  size={'small'}
                  value={requester}
                  onChange={handleChange.addSolicitante}
                  id="outlined-basic"
                  label="Solicitante"
                  variant="outlined"
                />
              </FormControl>
            </Box>
          )}
        </Toolbar>
        {(admin ||
          typist ||
          (routeTo === 'fiscalizacao' && geofi) ||
          (routeTo === 'educ' && education) ||
          (routeTo === 'engenharia' && tecEng)) &&
        routeTo !== 'sinistroSAMU' &&
        routeTo !== 'sinistrosSAMU' ? (
          routeTo === 'imprecisos' || routeTo === 'duplicidades' ? (
            <></>
          ) : (
            <Grid container justify="center">
              <Grid item className={classes.addIncidentButton}>
                <IconButton
                  className={classes.filterIconButton}
                  style={{ boxShadow: '0px 5px 4px #9E9E9E' }}
                  onClick={() => navigate(`/add/${routeTo}`)}
                >
                  <img
                    title="Adicionar registro"
                    className={classes.filterIcon}
                    src={Add}
                    alt="Adicionar registro"
                  />
                </IconButton>
              </Grid>
            </Grid>
          )
        ) : (
          <></>
        )}
      </AppBar>
    </>
  );
};

export default FilterBar;
